module.exports = __webpack_public_path__ + "img/verification-failed.811a83d2.svg";